import { DomEvent } from "./DomEvent";
import { Event } from "./Event";
import { RadioBox } from "../components/radio/RadioBox";
import { RadioBoxOption } from "../components/radio/RadioBoxOption";
import { RadioGroup } from "../components/radio/RadioGroup";
import { RadioOption } from "../components/radio/RadioOption";
import { RadioOptionSelectionEvent } from "./RadioOptionSelectionEvent";

export class RadioBoxOptionSelectionEvent extends RadioOptionSelectionEvent {
    constructor(component: RadioGroup, oldSelection: RadioOption, newSelection: RadioOption,
        originatingEvent?: Event|DomEvent) {
        super(component, oldSelection, newSelection, originatingEvent);
    }

    public override get group(): RadioBox {
        return super.group as RadioBox;
    }

    public get oldSelection(): RadioBoxOption {
        return super.oldSelection as RadioBoxOption;
    }

    public override get newSelection(): RadioBoxOption {
        return super.newSelection as RadioBoxOption;
    }

    public get event(): RadioBoxOptionSelectionEvent {
        return super.event as RadioBoxOptionSelectionEvent;
    }
}
